module.exports = __webpack_public_path__ + "img/ear-right.aa6b9b93.png";